var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveShareMixMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.09 106.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444a7f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.09,
    height: 106.09,
    rx: 53.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.45,59.13a5.49,5.49,0,1,1,.11-11,5.49,5.49,0,1,1-.11,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53,59.13a5.49,5.49,0,1,1,.15-11,5.49,5.49,0,1,1-.15,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.19,53.59a5.54,5.54,0,0,1-5.47,5.54,5.49,5.49,0,1,1-.1-11A5.53,5.53,0,0,1,82.19,53.59Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveShareMixMoreIcon);
export default __webpack_public_path__ + "static/media/SaveShareMixMoreIcon.70f26e27cb27164e1fd2d733708cad2c.svg";
export { ForwardRef as ReactComponent };